import { Link } from 'react-router-dom';
import { t, useLocale } from '../lib/i18n.js';
export function Press() {
  useLocale();
  const images = [
    ['01-overview', t('Overview', 'ゲームの概要')],
    ['02-solo', t('Solo round', '一人用ラウンド')],
    ['03-reveal', t('The reveal', '答え合わせ')],
    ['04-host', t('Host a game', 'ホスト式のゲーム')],
  ];
  return (
    <main className="page reading-page">
      <p className="eyebrow">{t('For curious people', '紹介してくださる方へ')}</p>
      <h1>{t('A game worth hearing about.', '耳で遊ぶ、ひらめきゲーム。')}</h1>
      <p>
        {t(
          'Listen & Draw turns English listening into a race to recognize a sketch. These assets show the real game. You’re welcome to use them when covering it.',
          'Listen & Drawは、英語を聞いて描画途中の絵を当てるゲームです。以下の素材は実際のゲーム画面で、紹介にご利用いただけます。',
        )}
      </p>
      <section>
        <h2>{t('The short version', '紹介文')}</h2>
        <blockquote>
          Listen to four English sentences, watch a sketch appear, and tap A–D as soon as you know
          which sentence it matches. Earlier correct answers score more. Try a solo round or host a
          game for friends or a class. No sign-up required.
        </blockquote>
        <p>
          {t('Maker & contact:', '制作者・お問い合わせ:')}{' '}
          <a href="https://x.com/phunter_jp" target="_blank" rel="noreferrer">
            @phunter_jp ↗
          </a>
        </p>
        <p>
          {t(
            'Available in English and Japanese. Free to play. Includes 100 original four-choice questions based on practical, everyday situations, with recorded English audio. Daily challenges and shareable results included.',
            '英語・日本語対応、無料。現実的な日常場面を扱うオリジナルの4択問題100問と英語音声を収録し、今日の一問・結果共有も楽しめます。',
          )}
        </p>
      </section>
      <section>
        <h2>{t('Images & video', '画像・動画')}</h2>
        <div className="press-assets">
          {images.map(([name, label]) => (
            <a key={name} href={`/press/${name}.png`} download>
              <img src={`/press/${name}.png`} alt={label} loading="lazy" />
              {label} · PNG ↓
            </a>
          ))}
        </div>
        <p>
          <a href="/press/listen-and-draw-demo.mp4" download>
            {t('Download the gameplay demo (MP4) ↓', 'ゲーム紹介動画をダウンロード（MP4）↓')}
          </a>
        </p>
        <p>
          <a href="/press/thumbnail.png" download>
            {t('Download the square thumbnail ↓', '正方形サムネイルをダウンロード ↓')}
          </a>
        </p>
      </section>
      <section>
        <h2>{t('Credit & context', 'クレジットと補足')}</h2>
        <p>
          {t(
            'Please credit Listen & Draw and link to this site. These are original game rounds, not exam questions. Solo scores are casual challenges, not proof of language proficiency. Live AI generation is experimental and is not required for the curated game.',
            'Listen & Drawの名前とこのサイトへのリンクを添えてください。収録内容はオリジナル問題です。一人用の得点は気軽な挑戦の記録で、英語能力の証明ではありません。リアルタイムのAI生成は実験的な機能で、同梱問題の利用には必要ありません。',
          )}
        </p>
        <Link className="btn btn--primary" to="/solo">
          {t('Play it yourself →', '実際に遊ぶ →')}
        </Link>
      </section>
    </main>
  );
}
